import { useEffect, useRef, useState } from "react";
import { useAuthContext } from "./AuthProvider";
import {
  CLOUD_HUMANS_BASE_URL as BASE_URL,
  CLOUD_HUMANS_WEBSITE_TOKEN as WEBSITE_TOKEN,
  enforceCloudHumansPanelStyle,
  listenCloudHumansWidget,
  markCloudHumansReady,
} from "../utils/cloudHumans";

export const CloudHumansWidget = () => {
  const { profile, isAuthenticated } = useAuthContext();
  const [isSdkReady, setIsSdkReady] = useState(false);
  const profileRef = useRef(profile);

  useEffect(() => {
    profileRef.current = profile;
  }, [profile]);

  useEffect(() => listenCloudHumansWidget(), []);

  useEffect(() => {
    if (document.getElementById("cloudhumans-sdk")) return;

    const script = document.createElement("script");
    script.id = "cloudhumans-sdk";
    script.src = `${BASE_URL}/packs/js/sdk.js?v=multi-1.0`;
    script.defer = true;
    script.async = true;

    window.cloudchatSettings = {
      ...window.cloudchatSettings,
      hideMessageBubble: true,
      showUnreadMessagesDialog: false,
    };

    script.onload = () => {
      window.cloudchatSDK.run({ websiteToken: WEBSITE_TOKEN, baseUrl: BASE_URL });

      window.addEventListener("cloudchat:ready", () => {
        setIsSdkReady(true);
        markCloudHumansReady();

        const currentProfile = profileRef.current;
        if (currentProfile?.email) {
          window.$cloudchat.setUser(currentProfile.email, {
            email: currentProfile.email,
            name: currentProfile.user_name,
            phone_number: currentProfile.phone_number ?? null,
          });
        }
      });

      window.addEventListener("cloudchat:on-start-conversation", () => {
        window.$cloudchat.setCustomAttributes({});
      });
    };

    document.getElementsByTagName("script")[0].parentNode?.insertBefore(
      script,
      document.getElementsByTagName("script")[0]
    );
  }, []);

  useEffect(() => {
    if (!isSdkReady) return;
    return enforceCloudHumansPanelStyle();
  }, [isSdkReady]);

  useEffect(() => {
    if (!isAuthenticated || !profile?.email || !isSdkReady || !window.$cloudchat) return;

    window.$cloudchat.setUser(profile.email, {
      email: profile.email,
      name: profile.user_name,
      phone_number: profile.phone_number ?? null,
    });
  }, [isAuthenticated, profile?.email, profile?.user_name, profile?.phone_number, isSdkReady]);

  return null;
};
